export const exercicioMesAnoParaMes = (exercicio: string) => {
  const mesAbreviado: keyof typeof meses = exercicio.split(' ')[0].toLowerCase() as keyof typeof meses;

  const meses: { [key: string]: number } = {
    jan: 1,
    fev: 2,
    mar: 3,
    abr: 4,
    mai: 5,
    jun: 6,
    jul: 7,
    ago: 8,
    set: 9,
    out: 10,
    nov: 11,
    dez: 12,
  };

  return meses[mesAbreviado] || 1;
};
